import React from 'react';
import { motion } from 'framer-motion';

const Header = () => (
  <header className="text-center mb-12">
    <motion.div 
      initial={{ y: -20, opacity: 0 }} 
      animate={{ y: 0, opacity: 1 }} 
      className="inline-block"
    >
      <a 
        href="https://NearMe.ph" 
        target="_blank" 
        rel="noopener noreferrer"
        className="block hover:opacity-80 transition-opacity"
      >
        <h1 className="text-4xl font-black text-slate-950 tracking-tighter mb-2">
          📍 NearMe <span className="text-indigo-600">Search</span>
        </h1>
      </a>
      <div className="h-2 w-16 bg-indigo-600 mx-auto rounded-full mb-4"></div>
    </motion.div>
    <motion.p 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      transition={{ delay: 0.2 }}
      className="text-slate-900 font-black text-[11px] uppercase tracking-[0.5em]"
    >
      Official Finder • Discover Local
    </motion.p>
  </header>
);

export default Header;